import { Navigate } from 'react-router-dom';

// Wrap any route element with this to require login (and optionally a
// specific role). Redirects to /login if there's no token, or to a fallback
// page if the logged-in user's role isn't allowed for this route.
function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem('token');
  const stored = localStorage.getItem('user');
  const user = stored ? JSON.parse(stored) : null;

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Logged in, but wrong role for this route — send them somewhere sane
    // instead of a blank/broken page.
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;